import _asyncToGenerator from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useState, useEffect, useRef } from 'react';
import { DEPLOY_ACTIONS, DEPLOY_MODE } from './constants';
import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from "@azure/msal-react";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import Image from '../../atoms/Image';
import DeployControls from './DeployControls';
import DeployControlsV2 from './DeployControlsV2';
import { getPath } from './utils';
var REVALIDATE_PATH = DEPLOY_ACTIONS.REVALIDATE_PATH,
  SYNC_APP = DEPLOY_ACTIONS.SYNC_APP,
  PUBLISHING_SCHEDULED = DEPLOY_ACTIONS.PUBLISHING_SCHEDULED;
function Login() {
  var _useMsal = useMsal(),
    instance = _useMsal.instance;
  return __jsx("div", {
    className: "nva-instant-preview__login"
  }, __jsx("p", {
    className: "u-caption"
  }, "Please, make sure to permit pop-ups in your browser settings in order to login"), __jsx("button", {
    type: "button",
    onClick: function onClick() {
      return instance.loginPopup();
    }
  }, __jsx(Image, {
    alt: "",
    src: "/svg/login.svg",
    width: 20,
    height: 20
  }), "Login"));
}
var AppServiceControls = function AppServiceControls(_ref) {
  var getSiteId = _ref.getSiteId;
  var _useState = useState(null),
    deployMode = _useState[0],
    setDeployMode = _useState[1];
  var _useState2 = useState(null),
    siteInfo = _useState2[0],
    setSiteInfo = _useState2[1];
  var _useState3 = useState(false),
    loading = _useState3[0],
    setLoading = _useState3[1];
  var _useState4 = useState([]),
    scheduledRevalidate = _useState4[0],
    setScheduledRevalidate = _useState4[1];
  var _useState5 = useState([]),
    scheduledSync = _useState5[0],
    setScheduledSync = _useState5[1];
  var _useState6 = useState([]),
    scheduledPublishing = _useState6[0],
    setScheduledPublishing = _useState6[1];
  var msalInstance = useRef(null);
  var shouldDisplayControls = process.env.NEXT_PUBLIC_DEPLOY_CONTROLS_ALLOWED_SITES.trim() === '' || process.env.NEXT_PUBLIC_DEPLOY_CONTROLS_ALLOWED_SITES.split(',').includes(getSiteId().toString());
  if (!shouldDisplayControls) {
    return null;
  }

  // MSAL configuration
  var msalConfig = {
    auth: {
      clientId: process.env.NEXT_PUBLIC_LOGIN_CLIENT_ID,
      authority: process.env.NEXT_PUBLIC_LOGIN_AUTHORITY,
      redirectUri: typeof window !== undefined && window.location.origin
    },
    cache: {
      cacheLocation: 'localStorage',
      // This configures where your cache will be stored
      storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
  };

  msalInstance.current = msalInstance.current || new PublicClientApplication(msalConfig);
  useEffect(function () {
    setLoading(false);
    msalInstance.current.initialize().then(function () {
      // Account selection logic is app dependent. Adjust as needed for different use cases.
      var accounts = msalInstance.current.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.current.setActiveAccount(accounts[0]);
      }
      msalInstance.current.addEventCallback(function (event) {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
          var account = event.payload.account;
          msalInstance.current.setActiveAccount(account);
        }
      });
    });
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var axios;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!siteInfo) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return import('axios');
            case 4:
              axios = _context.sent["default"];
              setLoading(true);
              axios({
                url: "".concat(process.env.NEXT_PUBLIC_ORCHESTRATOR_API_URL, "/getSiteInfo?siteId=").concat(getSiteId(), "&lastSyncApp=true&path=").concat(getPath(), "&includeScheduledProcessesPending=true"),
                method: 'get',
                headers: {
                  'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_ORCHESTRATOR_API_KEY
                }
              }).then(function (response) {
                var _response$data, _response$data$schedu, _response$data2, _response$data2$sched, _response$data3, _response$data3$sched;
                setDeployMode(response === null || response === void 0 ? void 0 : response.data.DeployMode);
                setSiteInfo(response === null || response === void 0 ? void 0 : response.data);
                setScheduledRevalidate((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$schedu = _response$data.scheduledProcessPending) === null || _response$data$schedu === void 0 ? void 0 : _response$data$schedu.filter(function (item) {
                  return item.Process === REVALIDATE_PATH;
                })) || []);
                setScheduledSync((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$sched = _response$data2.scheduledProcessPending) === null || _response$data2$sched === void 0 ? void 0 : _response$data2$sched.filter(function (item) {
                  return item.Process === SYNC_APP;
                })) || []);
                setScheduledPublishing((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$sched = _response$data3.scheduledProcessPending) === null || _response$data3$sched === void 0 ? void 0 : _response$data3$sched.filter(function (item) {
                  return item.Process === PUBLISHING_SCHEDULED;
                })) || []);
                setLoading(false);
              })["catch"](function (error) {
                console.error('error while trying to get the site info', error);
                setLoading(false);
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);
  return __jsx(MsalProvider, {
    instance: msalInstance.current
  }, __jsx(AuthenticatedTemplate, null, !process.env.NEXT_PUBLIC_USE_ORCHESTRATOR_V2 && __jsx(DeployControls, {
    getSiteId: getSiteId,
    deployMode: deployMode,
    siteInfo: siteInfo,
    loading: loading,
    setSiteInfo: setSiteInfo,
    scheduledRevalidate: scheduledRevalidate,
    scheduledSync: scheduledSync,
    setScheduledRevalidate: setScheduledRevalidate,
    setScheduledSync: setScheduledSync
  }), process.env.NEXT_PUBLIC_USE_ORCHESTRATOR_V2 && __jsx(DeployControlsV2, {
    getSiteId: getSiteId,
    siteInfo: siteInfo,
    loading: loading,
    setSiteInfo: setSiteInfo,
    setScheduledPublishing: setScheduledPublishing,
    scheduledPublishing: scheduledPublishing
  })), __jsx(UnauthenticatedTemplate, null, __jsx(Login, null)));
};
export default AppServiceControls;